export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["Confirmed"] = "confirmed";
  ActionType["Planned"] = "planned";
  ActionType["Virtual"] = "virtual";
  ActionType["Closed"] = "closed";
  ActionType["Canceled"] = "canceled";
  ActionType["Other"] = "other";
  return ActionType;
}({});